import { JsonReply, Partaker } from '@grupo-constant/next-dtype/types';
import { UserNodePrivileges, UserProfile } from '../projects/projects.types';
import { CompanyUser } from '../../../core/user/companyUser.model';

export const OU_URI = 'dtype://com.cloudcodice.thirdparty.grupoconstant.NextOu';
export const superuserOUProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileSuperuser';
export const developerOUProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileDeveloper';

export interface NextOu {
    ou?: string;
    name?: string;
    superuser?: UserProfile[];
    developer?: UserProfile[];
    role?: UserNodePrivileges;
    [superuserOUProfileUri]?: CompanyUser[] | string[] | UserProfile[];
    [developerOUProfileUri]?: CompanyUser[] | string[] | UserProfile[];
}

export interface RetrieveNextOuReply extends JsonReply {
    nextOu?: NextOu;
    partaker?: Partaker;
}

export interface UpdateNextOuReply extends JsonReply {
    nextOu?: NextOu;
}

export interface RetrieveNextPermissionsReply extends JsonReply {
    userNodePrivileges: UserNodePrivileges[];
    partaker: Partaker;
}

export interface UserNodePrivilegesForDisplay extends UserNodePrivileges {
    displayName: string;
    ouName: string;
    brandName: string;
    customerName: string;
    projectName: string;
    serviceName: string;
}
